import { makeStyles } from '@mui/styles';
import Blade from 'apollo-react/components/Blade';
import BladeGroup from 'apollo-react/components/BladeGroup';
import classNames from 'classnames';
import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { PILGRIM_TOP_MENU_HEIGHT } from '../../../constants/SizeConstants';
import { useFormSelector } from '../../../custom-hooks';
import { getUITA } from '../../../utils/commonUtils';
import { checkActiveContainers, removeSelectedSubGrid } from '../../actions/runtime.actions';
import { FormContext } from '../../context';
import SSSubGrid from '../../controls/ssSubGrid';
import {
  getBladeGroupWidthArr,
  getSelectedSubGridsWithActualIndexes,
} from '../../selectors/runtime.selectors';
import { equalityFn } from '../../utils/form-manager.utils';

const useStyles = makeStyles({
  root: {
    '& > :first-child': {
      borderLeft: '1px solid #e9e9e9',
    },
  },
  withoutBoxShadow: {
    '& > :first-child': {
      'box-shadow': 'none',
    },
  },
  nestedBlade: {
    '& > :first-child': {
      // paddingBottom: 74,
      height: 'calc(100% - 138px) !important',
    },
  },
});

const DesktopSelectedSubGrids = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const formKey = useContext(FormContext);
  const subGrids = useFormSelector(getSelectedSubGridsWithActualIndexes, {}, equalityFn);
  const bladeGroupWidthArr = useFormSelector(getBladeGroupWidthArr, { pathname }, equalityFn);

  const handleClose = (selectedSubGridRowId) => {
    dispatch(removeSelectedSubGrid(selectedSubGridRowId, formKey));
    dispatch(checkActiveContainers(formKey));
  };

  const getBlade = (subGrid, open, level) => {
    const {
      subgridId,
      gridIndex,
      row,
      isDetail,
      viewOnly,
      rowId,
      title,
      isParentlessTable,
      parentGridInstanceId,
    } = subGrid;

    return (
      <Blade
        open={open}
        title={title}
        width={bladeGroupWidthArr[level]}
        alwaysExpanded
        onClose={() => {
          handleClose(rowId);
        }}
        ui-ta={getUITA(open ? `BladeComponent_${level}` : '')}
        bodyProps={{ 'ui-ta': 'ScrollingElement' }}
        className={classNames(
          classes.root,
          classes.withoutBoxShadow,
          level === 1 ? classes.nestedBlade : ''
        )}
      >
        {open && (
          <div data-is-inside-blade="true" data-parent-grid-instanceid={parentGridInstanceId}>
            <SSSubGrid
              subgridId={subgridId}
              index={gridIndex}
              row={row}
              isDetail={isDetail}
              viewOnly={viewOnly}
              isParentlessTable={isParentlessTable}
            />
          </div>
        )}
      </Blade>
    );
  };

  // 3 blades are hardoced, but we can add more if needed
  // it cannot be rendered dynamically using map function due to BladeGroup's architecture design
  return (
    <BladeGroup side="right" marginTop={PILGRIM_TOP_MENU_HEIGHT}>
      {getBlade(subGrids[0] ?? {}, subGrids.length > 0, 0)}
      {getBlade(subGrids[1] ?? {}, subGrids.length > 1, 1)}
      {getBlade(subGrids[2] ?? {}, subGrids.length > 2, 2)}
    </BladeGroup>
  );
};

export default DesktopSelectedSubGrids;
